import DescriptionBox from './DescriptionBox';

export default DescriptionBox;
